// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { getIsWebCrawler } from "@insite/client-framework/Common/WebCrawler";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import { ConfigurationType } from "@insite/client-framework/Services/ProductServiceV2";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { ProductAvailabilityStyles } from "@insite/content-library/Components/ProductAvailability";
import { CustomAppState } from "@steiner/App/Store/Reducers";
import { isNonStockProduct, isNonStockProductProperty } from "@steiner/App/Store/Selectors/ProductDetailsSelector";
import ProductAvailability from "@steiner/Overrides/Components/ProductAvailability";
import React from "react";
import { connect } from "react-redux";

interface OwnProps {
    isProductDetailsPage?: boolean;
    configurationCompleted?: boolean;
    extendedStyles?: ProductAvailabilityStyles;
}

const mapStateToProps = (state: CustomAppState, ownProps: HasProduct) => {
    return {
        includeRealTimeInventoryAndPricingForSeo:
            getSettingsCollection(state).websiteSettings.includeRealTimeInventoryAndPricingForSeo,
        // XNG-Changes
        isNonStockPropertyItem: isNonStockProductProperty(state, ownProps.productInfo.productId),
        isNonStockItem: isNonStockProduct(state, ownProps.productInfo.productId),
    };
};

type Props = ReturnType<typeof mapStateToProps> & OwnProps & HasProduct;

const ProductContextAvailability = ({
    includeRealTimeInventoryAndPricingForSeo,
    productInfo,
    product,
    isProductDetailsPage,
    configurationCompleted,
    extendedStyles,
    // XNG-Changes
    isNonStockPropertyItem,
    isNonStockItem,
}: Props) => {
    const { inventory, unitOfMeasure, failedToLoadInventory } = productInfo;

    const availability =
        inventory?.inventoryAvailabilityDtos?.find(
            o => o.unitOfMeasure.toLowerCase() === (unitOfMeasure?.toLowerCase() || ""),
        )?.availability || undefined;

    if (
        (getIsWebCrawler() && !includeRealTimeInventoryAndPricingForSeo) ||
        product.isVariantParent ||
        (!!product.configurationType &&
            product.configurationType !== ConfigurationType.None &&
            product.configurationType !== ConfigurationType.Fixed &&
            !configurationCompleted) ||
        (isNonStockItem && isProductDetailsPage)
    ) {
        return null;
    }

    return (
        <ProductAvailability
            productId={product.id}
            trackInventory={product.trackInventory}
            availability={availability}
            unitOfMeasure={unitOfMeasure}
            isProductDetailsPage={isProductDetailsPage}
            failedToLoadInventory={failedToLoadInventory}
            extendedStyles={extendedStyles}
            // XNG-Changes
            isNonStockPropertyItem={isNonStockPropertyItem}
            qtyPerWarehouse={inventory?.additionalResults?.["qtyPerWarehouse"]}
            qtyOnHand={inventory?.qtyOnHand}
        />
    );
};

// XNG-Changes
export default withProduct(connect(mapStateToProps)(ProductContextAvailability));
